import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export default function Configuracoes() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 mc-container py-14 flex justify-center" data-testid="page-configuracoes">
        <div className="mc-card w-full max-w-lg p-8 mc-fade-up">
          <h1 className="text-3xl font-bold text-[#1e1b2e]">Configurações</h1>
          <p className="text-muted-foreground mt-2 text-sm">
            Preferências de notificação, privacidade e conta ainda não estão disponíveis nesta versão.
            Por enquanto, edite seus dados em{" "}
            <button className="text-violet-600 font-semibold underline underline-offset-2" onClick={() => navigate("/perfil")}>
              Meu Perfil
            </button>.
          </p>
          <button className="btn-outline w-full mt-8" data-testid="settings-logout-btn"
            onClick={async () => { await logout(); navigate("/"); }}>
            Sair da conta
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
